import _ from 'lodash';

export class ParamableCollection {
	constructor(params = []) {
		this._params = params;
	}

	count() {
		return this._params.length;
	}

	find(id) {
		return _.find(this._params, { id: id });
	}

	filterByType(type) {
		return _.where(this._params, { type: type });
	}

	add(paramable) {
		var match = this.find(paramable.id);
		if (match) {
			let index = _.indexOf(this._params, match);
			this._params.splice(index, 1, paramable);
		} else {
			this._params.push(paramable);
		}
	}

	addParamableCollection(pc) {
		_.each(pc, p => this.add(p));
	}

	remove(id) {
		_.remove(this._params, { id: id });
	}

	toHash() {
        var hash = {};
        _.each(this._params, p => {
            let param = p.toParam();
            hash[param.id] = param.value;
        });

        return hash;
	}

	toArray() {
		return this._params;
	}

	toParamArray() {
		return _.map(this._params, p => p.toParam());
	}
}
